import React from "react";

export default function Footer() {
  return (
    <footer>
      <div className="foot-row">
        <pre className="sig">{` _                                    
| |__  _ __ _   _ ___  ___  _ __      
| '_ \\| '__| | | / __|/ _ \\| '_ \\     
| |_) | |  | |_| \\__ \\ (_) | | | |    
|_.__/|_|   \\__, |___/\\___/|_| |_|    
            |___/                     `}</pre>
        <div className="meta">
          <span><span className="k">github </span><span className="v">@brysonwaisi</span></span>
          <span><span className="k">domain </span><span className="v">nyamwangeb.com</span></span>
        </div>
      </div>
      <div className="check">
        © {new Date().getFullYear()} Bryson Nyamwange ·{" "}
        <span className="ac">all source on github.com/brysonwaisi</span>
      </div>
    </footer>
  );
}
